import { mapState, mapActions } from 'vuex';

import { STATUS_CONTA, BANCOS_HOMOLOGADOS, BANCOS_IMOBILIARIA } from '../../util/constantes.js';
import Util from '../../util/funcoes.js';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  components: {
    FontAwesomeIcon
  },

  data() {
    return {
      infiniteLoadingId: 0,
      validacao: {
        status: [
          { required: true, message: "Status é obrigatório" }
        ],
        banco: [
          { required: true, message: "Banco é obrigatório" }
        ],
        nome: [
          { required: true, message: "Nome é obrigatório" }
        ],
        titular: [
          { required: true, message: "Titular é obrigatório" }
        ],
        agencia: [
          { required: true, message: "Agência é obrigatório" }
        ],
        digitoAgencia: [
          { required: true, message: "O Dígito da Agência é obrigatório" }
        ],
        conta: [
          { required: true, message: "Conta é obrigatório" }
        ],
        digitoConta: [
          { required: true, message: "O Dígito da Conta é obrigatório" }
        ]
      },

      diasBaixaBoletoOptions: [
        { label: '30', data: 30 },
        { label: '60', data: 60 }
      ],

      hoverGravar: false,
      hoverRemover: false,

      webhooks: []
    }
  },
  computed: {
    ...mapState('loginStore', {
      permissoes(state) {
        return state.usuarioLogado.permissoes
          .filter((permissao) => {
            return permissao.modulo === 'CONTAS_BANCARIAS'
          })[0];
      },
      usuarioLogado(state) {
        return state.usuarioLogado;
      },
    }),
    ...mapState('contasBancariasStore', {
      contas(state) { return state.listaContas; },
      contaPesquisa(state) { return state.contaPesquisa; },
      labelQuantidade(state) { return state.labelQuantidade; },
      conta(state) { return state.contaSelecionada; },
    }),
    contaIsBancoDoBrasil() { return this.conta.banco === 'BANCO_DO_BRASIL' },
    contaIsSicredi() { return this.conta.banco === 'SICRED' },
    contaIsInter() { return this.conta.banco === 'INTER' },
    contaIsCora() { return this.conta.banco === 'CORA' },
    contaIsAsaas() { return this.conta.banco === 'ASAAS' },
    bancos() { return BANCOS_IMOBILIARIA; },
    statusConta() { return STATUS_CONTA; },
    exibirContas() {
      return this.permissoes.visualizacao
    },
    exibirBotaoGravarConta() {
      return(
        (this.conta.id === 0 && this.permissoes.cadastro)
        || (this.conta.id !== 0 && this.permissoes.alteracao)
      )
    },
    exibirBotaoRemoverConta() { return this.conta.id != 0 && this.permissoes.remocao; },
    util() { return Util },
    contaTemBoletoHibrido() {
      return this.conta.banco === 'ITAU' ||
      this.conta.banco === 'SICRED' ||
      this.conta.banco === 'BRADESCO' || 
      this.conta.banco === 'CORA' ||
      this.conta.banco === 'BANCO_DO_BRASIL'
    },
    exibirEmissaoBoletoRemessa(){
      return !(this.conta.banco === 'BANCO_DO_NORDESTE' || this.conta.banco === 'NUBANK');
    },
    exibirNumeroRemessaPagmentos(){
      return !(this.conta.banco === 'BANCO_BTG_PACTUAL' || 
      this.conta.banco === 'CAIXA_ECONOMICA' || 
      this.conta.banco === 'INTER' || this.conta.banco === 'SANTANDER' || 
      this.conta.banco === 'SICOOB' || this.conta.banco === 'SICRED');
    },
    exibirCodigoEmpresa(){
      return this.conta.banco === 'BRADESCO' || 
      this.conta.banco === 'SANTANDER' || 
      this.conta.banco === 'SICRED';
    },
    exibirCarteira(){
      return this.conta.banco === 'BANCO_BTG_PACTUAL' || 
      this.conta.banco === 'CAIXA_ECONOMICA' || 
      this.conta.banco === 'SICRED' ||  this.conta.banco === 'SICOOB'  ||
      this.conta.banco === 'ITAU' ||  this.conta.banco === 'INTER';
    },
    ocutarCamposRemessa() {
      return !(this.conta.banco === 'CORA' ||
      this.conta.banco === 'ASAAS')
    },
    isVisualizarWebhooks() {
      return this.usuarioLogado.suporte;
    }
  },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('contasBancariasStore', [
      'listarContas',
      'limparContasListadas',
      'limparContaPesquisa',
      'recuperarConta',
      'novaConta',
      'gravarConta',
      'removerConta',
      'listarWebhooksAsaas',
      'removerWebhook',
      'novoWebhookPagamentosAsaas'
    ]),

    blurBancoSelect() {
      this.$refs.bancoSelect.blur();
    },

    selecionarBanco(banco) {
      if(!banco) {
        return;
      }

      const bancosHomologados = BANCOS_HOMOLOGADOS.map(object => object.data).filter(banco => banco !== '');
      if(!bancosHomologados.includes(banco)) {
        this.exibirAlert('Atenção', 'Não será possível gerar boletos através do banco selecionado pois ele não é homologado.',  { callback: this.blurBancoSelect });
      }
    },

    validarInputNumeracaoRemessa($event) {
      const valoresPermitidos = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

      if(!valoresPermitidos.includes($event.key)) {
        $event.preventDefault();
      }
    },
    pesquisar($state) {
      if(this.contaPesquisa.pagina === 0) { this.showLoading(); }
      this.listarContas(this.contaPesquisa)
        .then((resultado) => {
          if(this.contaPesquisa.pagina === 0) { this.hideLoading(); }

          if(resultado.lista.length === 100) {
            this.contaPesquisa.pagina += 1;
            $state.loaded();
          } else if(resultado.lista.length > 0 && this.contaPesquisa.pagina === 0) {
            $state.loaded();
            $state.complete();
          } else {
            $state.complete();
          }
        }).catch(() => {
          if(this.contaPesquisa.pagina === 0) { this.hideLoading(); }
          this.$message.error("Não foi possível conectar-se ao servidor");
        });
    },
    pesquisarHandler() {
      this.contaPesquisa.pagina = 0;
      this.limparContasListadas();
      this.infiniteLoadingId += 1;
    },
    novaContaHandler() {
      this.$refs["form"].resetFields();
      this.novaConta();
    },
    limparPesquisa() {
      this.limparContaPesquisa();
    },
    recuperarHandler(conta) {
      this.recuperar(conta);
    },
    recuperar(conta) {
      this.showLoading();
      this.recuperarConta(conta).then(() => {
        if(this.conta.banco === 'ASAAS') {
          this.listarWebhooksAsaasHandler(conta);
        }
        this.hideLoading();
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },
    gravarHandler() {
      this.$refs['form'].validate((valid) => {
        if(valid) {
          this.gravar();
        } else {
          this.exibirAlert("Atenção", "Preencha todos os campos obrigatórios");
        }
      });
    },
    gravar() {
      this.showLoading();

      const payload = {
        ...this.conta,
        webhooks: undefined
      }

      this.gravarConta(payload).then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.pesquisarHandler();
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },
    exibirAlert(titulo, mensagem, { type=undefined, callback=undefined }) {
      this.$alert(mensagem, titulo, { confirmButtonText: "OK", type, callback });
    },
    removerContaHandler() {
      this.$confirm('Deseja realmente remover esta Conta Bancária?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        this.remover();
      });
    },
    remover() {
      this.showLoading();
      this.removerConta(this.conta).then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
          case "FALHA":
            this.exibirAlert('Atenção', resultado.mensagem, { type: 'error' });
            break;
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.pesquisarHandler();
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      })
    },

    coresPesquisa(status) {
      switch(status) {
        case "ATIVO":
          return "#2DB748";
        case "INATIVO":
          return "#DF1B1B";
      }
    },

    listarWebhooksAsaasHandler(contaBancaria) {
      this.listarWebhooksAsaas(contaBancaria);
    },

    removerWebhookHandler(webhook) {
      const payload = {
        ...webhook,
        conta: {
          ...this.conta,
          webhooks: undefined
        }
      }

      this.showLoading();

      this.removerWebhook(payload)
      .then(resposta => {
        switch (resposta.status) {
          case "SUCESSO":
            this.$message.success(resposta.mensagem)
            break;
          case "ERRO":
            this.$message.success(resposta.mensagem)
            break;
        }
      }).catch(() => {
        this.$message.error('Erro ao comunicar-se com o servidor!')
      }).finally(() => {
        this.hideLoading();
      })
    },

    novoWebhookPagamentosAsaasHandler() {
      this.showLoading();

      const payload = {
        ...this.conta,
        webhooks: undefined
      }

      this.novoWebhookPagamentosAsaas(payload)
      .then(resposta => {
        switch (resposta.status) {
          case "SUCESSO":
            this.$message.success(resposta.mensagem);
            this.listarWebhooksAsaasHandler(this.conta);
            break;
          case "ERRO":
            this.$message.success(resposta.mensagem)
            break;
        }
      }).catch(() => {
        this.$message.error('Erro ao comunicar-se com o servidor!')
      }).finally(() => {
        this.hideLoading();
      })
    }
  }
}